module.exports = __webpack_public_path__ + "img/LamdeiniLearning-20.2a708580.jpg";